import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { PageErrorBoundary } from '@vivicta/ui';

const agentStatusPage = PageBlueprint.make({
  params: {
    path: '/agent-status',
    // The page renders its own `Header`; without this the blueprint stacks a
    // `PluginHeader` bar titled after the plugin id above it.
    noHeader: true,
    loader: () =>
      import('./components/AgentStatusPage').then(m => (
        <PageErrorBoundary title="Agent jobs">
          <m.AgentStatusPage />
        </PageErrorBoundary>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'vivicta-agent-status',
  extensions: [agentStatusPage],
});
